import * as store from '@daas-consulting/core-frontend-store';
import * as models from '@daas-consulting/production/remitos/frontend/models';
import { context, feature } from '../remitos.const';

const getItemActions = store.getActionsNames({
  context,
  feature,
  section: store.SectionsNames.detailPreview,
  action: store.DetailPreviewActionNames.getItem,
});

export class GetItem {
  static readonly type = `${getItemActions.action}`;
  constructor(readonly payload: string) {}
}

export class GetItemRequest {
  static readonly type = `${getItemActions.request}`;
}

export class GetItemSuccessful {
  static readonly type = `${getItemActions.successful}`;
  constructor(readonly payload: models.detailPreview.ItemView) {}
}

export class GetItemFailure {
  static readonly type = `${getItemActions.failure}`;
  constructor(readonly payload: Error) {}
}
